module.exports = __webpack_public_path__ + "static/media/logo_vert_amarillo.53dfac68.svg";